/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * What a logged-in member sees about their membership payments on the public site.
 * @export
 */
export const WebApiModelsEnumerationTypesPublicPaymentDisplay = {
    NUMBER_0: 0,
    NUMBER_1: 1,
    NUMBER_2: 2
} as const;
export type WebApiModelsEnumerationTypesPublicPaymentDisplay = typeof WebApiModelsEnumerationTypesPublicPaymentDisplay[keyof typeof WebApiModelsEnumerationTypesPublicPaymentDisplay];


export function WebApiModelsEnumerationTypesPublicPaymentDisplayFromJSON(json: any): WebApiModelsEnumerationTypesPublicPaymentDisplay {
    return WebApiModelsEnumerationTypesPublicPaymentDisplayFromJSONTyped(json, false);
}

export function WebApiModelsEnumerationTypesPublicPaymentDisplayFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiModelsEnumerationTypesPublicPaymentDisplay {
    return json as WebApiModelsEnumerationTypesPublicPaymentDisplay;
}

export function WebApiModelsEnumerationTypesPublicPaymentDisplayToJSON(value?: WebApiModelsEnumerationTypesPublicPaymentDisplay | null): any {
    return value as any;
}

